import { render, staticRenderFns } from "./UserDetailHistoryTab.vue?vue&type=template&id=58fa72fc&scoped=true&lang=pug&"
import script from "./UserDetailHistoryTab.vue?vue&type=script&lang=js&"
export * from "./UserDetailHistoryTab.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailHistoryTab.vue?vue&type=style&index=0&id=58fa72fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fa72fc",
  null
  
)

export default component.exports